import { trackEvent } from '../../../middleware/createAnalyticsMiddleware';
import { EVENT_CATEGORY } from './constants';

interface EventProps {
    eventAction?: string;
    eventLabel?: string;
    eventValue?: string;
    options?: Object;
}

export const trackReservationModuleEvent = ({ eventAction, eventLabel, eventValue, options }: EventProps) =>
    trackEvent({ eventCategory: EVENT_CATEGORY, eventAction, eventLabel, eventValue, options });
